import { useQuery } from '@tanstack/react-query';
import { dashboardApi } from '../api/endpoints/dashboard';

export function useAdminDashboard() {
  return useQuery({
    queryKey: ['admin-dashboard'],
    queryFn: () => dashboardApi.getStats().then((r) => r.data.data)
  });
}
